import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const ProtectedRoute = ({ children, requiredRole = null, requiredPermission = null }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role?.name !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  // Permission gate. Super admins bypass (they own everything); everyone else
  // must carry the key. Missing → bounce to the org-admin home rather than the
  // user area, since permission-gated pages live under /org-admin.
  if (requiredPermission && !user?.isSuperAdmin && !user?.permissions?.includes(requiredPermission)) {
    return <Navigate to="/org-admin" replace />;
  }

  return children;
};
